/*
 * @Description: 分销推广api
 * @Author: Gavin
 * @version: 
 * @Date: 2020-09-01 14:39:28
 * @LastEditTime: 2020-09-01 15:40:15
 */

import { request } from './axiosConfig';

const rootUrl = '/xdnphb/';

//根据推广类型获取用户推广权限
export const getPopularizeAuthByType = (params) => {
	return request.get(`${rootUrl}ade/v1/api/popularize/getPopularizeAuthByType`, params);
};

//获取用户所有推广权限
export const getPopularizeAuthList = (params) => {
	return request.get(`${rootUrl}ade/v1/api/popularize/getPopularizeAuthList`, params);
};

//根据推广类型获取用户推广链接
export const getPopularizeLink = (params) => {
	return request.get(`${rootUrl}ade/v1/api/popularize/getPopularizeLink`, params);
};

//获取用户每日推广统计
export const getPopularizeStatisticsByDate = (params) => {
	return request.get(`${rootUrl}ade/v1/api/cpsPopularize/getPopularizeStatisticsByDate`, params);
};

//获取用户总推广统计
export const getAllPopularizeStatisticsForUser = (params) => {
	return request.get(`${rootUrl}ade/v1/api/cpsPopularize/getAllPopularizeStatisticsForUser`, params);
};

//获取用户推广订单记录
export const getIndentList = (params) => {
	return request.get(`${rootUrl}ade/v1/api/cpsPopularize/getIndentList`, params);
};

//获取用户全部推广记录
export const getPopularizeRecords = (params) => {
	return request.get(`${rootUrl}ade/v1/api/cpsPopularize/getPopularizeRecords`, params);
};

//获取得到用户的统计佣金数据
export const getCpsCommissionStatisticsForUser = (params) => {
	return request.get(`${rootUrl}ade/v1/api/cpsPopularize/getCpsCommissionStatisticsForUser`, params);
};
